import React, { useState } from 'react';

import '../../lib/request';

export const ServiceCalendarTitle = ({ onRefreshDate, titleHeadingText }) => {
    const handleRefreshDateClick = () => {
        const prevDate = new Date();
        prevDate.setDate(new Date().getDate() - 5);
        onRefreshDate(prevDate, new Date());
    };

    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center' }} className="space service_calender_title">
            <span style={{ marginRight: '50px' }}>{titleHeadingText}</span>
            <span className="service_calender_title_color" style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={handleRefreshDateClick}>
                {formatDate(new Date())}
            </span>
        </div>
    );
};
